import trim from './trim/index' // 引入需要的指令
import permission from './permission/index' // 按钮权限指令

const directivesList: any = {
  trim, // 挂载
  permission
}

const directives = {
  install: function (app: any) {
    Object.keys(directivesList).forEach((key) => {
      app.directive(key, directivesList[key]) // 注册
    })
  }
}

export default directives // 抛出
